import React from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import { useSettings } from '../../contexts/SettingsContext';
import { useCustomer } from '../../contexts/CustomerContext';

const MaintenanceBanner = () => {
    const { settings, clientMaintenance, availableClients } = useSettings();
    const { currentCustomer } = useCustomer();

    // Check if current client is in maintenance mode
    const isCurrentClientInMaintenance = currentCustomer && 
        clientMaintenance.includes(currentCustomer.id);

    // Don't show banner if no maintenance is active
    if (!settings.maintenance_mode && !isCurrentClientInMaintenance) {
        return null;
    }

    // Get client names for display
    const getClientName = (clientId) => {
        const client = availableClients.find(c => c.id === clientId);
        return client ? (client.displayName || client.name || client.id) : clientId;
    };

    const getMaintenanceMessage = () => {
        if (settings.maintenance_mode) {
            return "System-wide maintenance in progress";
        } else if (isCurrentClientInMaintenance) {
            return `Maintenance in progress for ${getClientName(currentCustomer.id)}`;
        }
        return "Maintenance in progress";
    };

    const getMaintenanceDetails = () => {
        if (settings.maintenance_mode) {
            return "The entire application is currently under maintenance. Some features may be unavailable.";
        } else if (isCurrentClientInMaintenance) {
            return `Your organization (${getClientName(currentCustomer.id)}) is currently under maintenance. Some features may be unavailable.`;
        }
        return "Some features may be unavailable.";
    };

    return (
        <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white shadow-lg">
            <div className="flex items-center justify-center gap-2 px-4 py-3 text-center">
                <Icon icon="mdi:maintenance" className="text-xl" />
                <span className="font-semibold">
                    {getMaintenanceMessage()}
                </span>
                <span className="text-red-100 text-sm">
                    - {getMaintenanceDetails()}
                </span>
            </div>
        </div>
    );
};

export default MaintenanceBanner;
